export function mergeAssetSummaries(activity) {
  if (!activity) return [];

  const assetMap = new Map();

  // Normalizar siempre a array
  const userSummary = (() => {
    if (typeof activity.user_asset_summary === "string") {
      try {
        return JSON.parse(activity.user_asset_summary);
      } catch {
        return [];
      }
    }
    return Array.isArray(activity.user_asset_summary)
      ? activity.user_asset_summary
      : [];
  })();

  const supervisorSummary = (() => {
    if (typeof activity.supervisor_asset_summary === "string") {
      try {
        return JSON.parse(activity.supervisor_asset_summary);
      } catch {
        return [];
      }
    }
    return Array.isArray(activity.supervisor_asset_summary)
      ? activity.supervisor_asset_summary
      : [];
  })();

  // Datos del usuario
  userSummary.forEach((u) => {
    assetMap.set(u.assetUid, {
      assetUid: u.assetUid,
      assetTitle: u.assetTitle,
      userTotal: parseInt(u.total, 10),
      supervisorTotal: null,
    });
  });

  // Datos del supervisor
  supervisorSummary.forEach((s) => {
    const existing =
      assetMap.get(s.assetUid) || {
        assetUid: s.assetUid,
        assetTitle: s.assetTitle,
        userTotal: null,
        supervisorTotal: null,
      };
    existing.supervisorTotal = parseInt(s.total, 10);
    assetMap.set(s.assetUid, existing);
  });

  // Calcular diferencia
  return Array.from(assetMap.values()).map((asset) => ({
    ...asset,
    difference:
      asset.userTotal != null && asset.supervisorTotal != null
        ? asset.userTotal - asset.supervisorTotal
        : null,
  }));
}
